import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { categories } from "../mock";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import useReveal from "../hooks/useReveal";

function CategoryCard({ c }) {
  const to = c.id === "strength" ? "/collection/weight-sets" : "/collection/weight-sets";
  return (
    <Link
      to={to}
      className="group flex w-[280px] shrink-0 snap-start flex-col overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl md:w-auto"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={c.image}
          alt={c.name}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-heading text-lg font-bold text-navy">{c.name}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-navy/60">{c.desc}</p>
        <span className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full border-2 border-navy px-5 py-2 text-xs font-bold uppercase tracking-wide text-navy transition-all group-hover:border-brand group-hover:bg-brand group-hover:text-white">
          Browse <ArrowRight size={14} />
        </span>
      </div>
    </Link>
  );
}

export default function Categories() {
  const scroller = useRef(null);
  const ref = useReveal();
  const scroll = (dir) => {
    scroller.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  };
  return (
    <section id="categories" className="bg-gray-50 py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-extrabold text-navy md:text-3xl">
              Top Categories
            </h2>
            <p className="mt-2 text-sm text-navy/60">
              Check out our most popular fitness equipment categories.
            </p>
          </div>
          <div className="hidden gap-2 md:flex">
            <button onClick={() => scroll(-1)} className="flex h-10 w-10 items-center justify-center rounded-full border border-navy/20 text-navy transition-colors hover:bg-navy hover:text-white" aria-label="Previous"><ChevronLeft size={18} /></button>
            <button onClick={() => scroll(1)} className="flex h-10 w-10 items-center justify-center rounded-full bg-navy text-white transition-colors hover:bg-brand" aria-label="Next"><ChevronRight size={18} /></button>
          </div>
        </div>
        <div
          ref={scroller}
          className="no-scrollbar flex snap-x gap-5 overflow-x-auto pb-2 md:grid md:grid-cols-4 md:overflow-visible"
        >
          {categories.map((c) => (
            <CategoryCard key={c.id} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
}
